import React from 'react';
import PropTypes from 'prop-types';

import Indicator from './LoadingIndicator/Indicator';

/**
 * Wrap around a component to show a loading indicator when async operations
 * are in progress.
 *
 * {@code
 * <LoadingIndicator isLoading={this.state.isLoading}>
 *   <DataRenderer {...this.state} />
 * </LoadingIndicator>
 * }
 *
 * @param isLoading boolean true if the indicator should be shown
 * @param children Component Provide a single child component to show when
 *                           not loading.
 */

const LOADING = 'loading...';

export default function LoadingIndicator(props) {
    if (props.isLoading) {
        return <Indicator {...props} />;
    }

    return (<div style={{ height: '100%', width: '100%' }}>
        {props.children}
    </div>);
}

LoadingIndicator.propTypes = {
    isLoading: PropTypes.bool,
    orientation: PropTypes.oneOf(['left', 'middle']).isRequired,
    text: PropTypes.string,
    children: PropTypes.any,
    useOverlay: PropTypes.bool,
};

LoadingIndicator.defaultProps = {
    isLoading: true,
    text: LOADING,
    orientation: 'middle',
    useOverlay: false,
    children: null,
};
